import classNames from 'classnames';
import React from 'react';

import css from './IconMarker.module.css';

const DEFAULT_WIDTH = 16;

const IconMarker = props => {
  const { className, rootClassName, width } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      version="1.0"
      id="IconMarker"
      width={width}
      viewBox="0 0 2680.52 4223.2"
      enableBackground="new 0 0 2680.52 4223.2"
    >
      <path
        d="M638.72,2925c60.8,108.1,116.9,208,124.8,222c7.8,14,17.1,30.4,20.5,36.5c6.7,11.7,58,103,65,115.5
	c2.3,4.1,59.2,105.4,126.5,225c67.2,119.6,126.2,224.5,131,233c13.2,23.6,73.8,131.3,106,188.5c15.8,28,56.5,100.5,90.5,161
	c33.9,60.5,62.5,111.3,63.5,112.9l1.7,2.8l4-7.3c4.2-7.7,11.6-21.4,49.8-92.9c12.5-23.4,29.4-54.9,37.5-70
	c8.1-15.1,43.7-81.5,79-147.5c90.2-168.5,176.7-329.9,180.5-337c1.8-3.3,22-41.1,45-84c23-42.9,43.2-80.7,45-84
	c1.8-3.3,8.4-15.7,14.7-27.5c6.4-11.8,13.3-24.9,15.6-29c4.1-7.6,141.7-264.7,170-317.5c8.5-16,28.8-53.8,45-84
	c47.6-88.8,59-110.1,67.5-126c9.6-18.1,111.4-208.1,116.7-218c2.1-3.9,56.3-105.1,120.5-225s125.1-233.5,135.3-252.5
	c20.8-38.9,43.7-84.5,56.2-112c69.8-154.4,112.1-318,125.4-484.5c3.4-42.1,4.1-61.3,4.1-115c0-63.5-1.6-95.6-7.6-152.5
	c-31.5-303.2-160.8-595.9-361.8-819.5c-96.2-106.9-206.1-196.3-326.8-265.8c-104.3-60.1-213.9-104.3-328.6-132.6
	c-80.3-19.8-150.2-30.4-239.2-36.1c-21.6-1.4-104.5-2-128-1c-117.4,5.3-225.9,24-333,57.4c-197.4,61.4-378,171-528.5,320.6
	c-21.1,21-28.2,28.3-46.5,48.1c-14.5,15.5-40.3,45.6-56.6,65.9c-148.3,184.2-249.9,403.4-295.8,638
	c-60.9,312.3-18.7,632.1,121.3,917.6C172.12,2095.7,112.72,1989.4,638.72,2925z M870.52,758.6c118.7-108.5,269.4-172.4,430.5-182.5
	c19.1-1.2,65.6-1.2,84.5-0.1c114.9,7.1,222.8,40.2,319.5,98.3c144.9,87,253.5,222.3,306.5,381.8c52.6,158.4,46.6,334.4-16.8,488.4
	c-92.6,225-296.6,387.6-535.2,426.4c-44.5,7.3-78,9.6-127.5,8.8c-42.8-0.7-69.6-3-106.4-9.3c-190.8-32.6-360.4-143.3-467.5-305.2
	c-74.1-112.1-113.1-237.4-116.3-373.7C637.22,1089.9,720.42,896,870.52,758.6z"
      />
    </svg>
  );
};

IconMarker.defaultProps = {
  width: DEFAULT_WIDTH,
};

export default IconMarker;
